module.exports = __webpack_public_path__ + "static/media/IMAGE-ADVISORY-BOARD.3d68978b.png";